import { put } from 'redux-saga/effects';
import { LongSteelShoppingCartService } from '../../../services/LongSteelShoppingCart';
import { cleanLastOrder } from '../long-steel-order-item-search/actions';
import {
  finishOrderFailure,
  finishOrderSuccess,
  updateLongSteelShoppingCartSettings
} from './actions';
import {
  ILongSteelOrderItem,
  ILongSteelShoppingCartState,
  Types
} from './types';
interface IUpdateShoppingCartParams {
  payload: {
    longSteelShoppingCartState: ILongSteelShoppingCartState;
  };
  type: Types;
}

interface ISendOrderParams {
  payload: {
    items: ILongSteelOrderItem[];
    emitterId: string;
    receiverId: string;
    customerOrder: string;
  };
  type: Types;
}

export function* loadLongSteelShoppingCartFromLocalStorageSaga() {
  try {
    const shopCartService = new LongSteelShoppingCartService();
    const shoppingCartStateLocalStorage: ILongSteelShoppingCartState =
      yield shopCartService.getLongSteelShoppingCartFromLocalStorage();

    yield put(
      updateLongSteelShoppingCartSettings(shoppingCartStateLocalStorage)
    );
  } catch (err) {
    console.error('loadShoppingCartFromLocalStorage', err);
  }
}

export function* updateLongSteelShoppingCartSaga(
  params: IUpdateShoppingCartParams
) {
  try {
    const { longSteelShoppingCartState } = params.payload;
    const shopCartService = new LongSteelShoppingCartService();
    yield shopCartService.updateShoppingCartStateLocalStorage(
      longSteelShoppingCartState
    );
  } catch (err) {
    console.error('updateLongSteelShoppingCartSaga', err);
  }
}

export function* sendLongSteelOrderSaga(params: ISendOrderParams) {
  try {
    const { items, emitterId, receiverId, customerOrder } = params.payload;
    const shopCartService = new LongSteelShoppingCartService();
    const createdOrders: string[] = yield shopCartService.sendOrder(
      items,
      emitterId,
      receiverId,
      customerOrder
    );
    yield put(finishOrderSuccess(createdOrders));
    yield put(cleanLastOrder());
  } catch (err) {
    console.error('sendOrderSaga', err);
    yield put(finishOrderFailure(err));
  }
}
